import { atom } from "recoil";

interface DiagramSaveState {
    hasChanges: boolean;
    save: (() => void) | null;
}

export const diagramSaveAtom = atom<DiagramSaveState>({
    key: "diagramSaveAtom",
    default: {
        hasChanges: false,
        save: null,
    },
});
